import React, { useState, useEffect } from "react";
import Sidebar from "../profile-sidebar/profileSidebar";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Layout from "../layout/layout";
import { updateInfoUser } from "../../redux/slices/userSlice";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import Select from "react-select";
import "./update-user.css";
import AddressMap from "../maps/address-map";
const UpdateUser = () => {
  const { user } = useSelector((state) => state.auth);
  const { userInfo } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [initialData, setInitialData] = useState({
    fullName: "",
    address: "",
    email: "",
    phoneNumber: "",
    imageUrl: "",
    statusGuide: "",
  });

  const [formData, setFormData] = useState({
    fullName: "",
    address: "",
    email: "",
    phoneNumber: "",
    imageUrl: "",
    statusGuide: "",
  });

  // Lấy role và statusGuide từ token và userInfo
  const decoded = jwtDecode(user);
  const roleName =
    decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
  const isTourGuide = roleName === "Tour guide";

  useEffect(() => {
    if (userInfo) {
      const newData = {
        fullName: userInfo.fullName || "",
        address: userInfo.address || "",
        email: userInfo.email || "",
        phoneNumber: userInfo.phoneNumber || "",
        imageUrl: userInfo.imageUrl || "",
        statusGuide: userInfo.statusGuide || "",
      };

      setFormData(newData);
      setInitialData(newData); // Lưu dữ liệu gốc để so sánh
    }
  }, [userInfo, formData.imageUrl]);

  // State lưu lỗi
  const [errors, setErrors] = useState({});

  // Xử lý khi người dùng nhập vào input
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Khi người dùng nhập lại, lỗi sẽ biến mất
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Xóa lỗi ngay khi người dùng nhập lại
    }));
  };

  const handleLocationChange = ({ address, coordinates }) => {
    let newAddress = address;
    if (coordinates) {
      // Gán tọa độ vào address dưới dạng chuỗi JSON
      newAddress = `${address} (Lat: ${coordinates.lat.toFixed(
        6
      )}, Lon: ${coordinates.lon.toFixed(6)})`;
    }
    setFormData((prev) => ({
      ...prev,
      address: newAddress,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      address: "",
    }));
  };

  // Kiểm tra dữ liệu trước khi gửi
  const validateForm = () => {
    let newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = "Vui lòng nhập tên";

    if (isTourGuide) {
      // Validation cho Tour Guide
      if (!formData.address.trim())
        newErrors.address = "Hướng dẫn viên bắt buộc phải có địa chỉ.";
      if (!formData.phoneNumber.trim()) {
        newErrors.phoneNumber =
          "Hướng dẫn viên bắt buộc phải có số điện thoại.";
      } else if (!/^0\d{9}$/.test(formData.phoneNumber)) {
        newErrors.phoneNumber =
          "Số điện thoại phải bắt đầu bằng 0 và có đúng 10 số";
      }
    } else {
      // Validation cho user thường
      if (
        formData.phoneNumber.trim() &&
        !/^0\d{9}$/.test(formData.phoneNumber)
      ) {
        newErrors.phoneNumber =
          "Số điện thoại phải bắt đầu bằng 0 và có đúng 10 số";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Hàm kiểm tra dữ liệu có thay đổi không
  const isDataChanged = () => {
    return (
      formData.fullName !== initialData.fullName ||
      formData.address !== initialData.address ||
      formData.phoneNumber !== initialData.phoneNumber ||
      formData.statusGuide !== initialData.statusGuide ||
      selectedImage !== null
    );
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
      setImageFile(file);
    }
    e.target.value = "";
  };

  // Xử lý khi nhấn nút "Lưu"
  const handleSubmit = async () => {
    if (!isDataChanged()) {
      toast.info("Không có thay đổi nào để cập nhật!");
      return;
    }
    try {
      if (validateForm()) {
        setUploading(true);
        let url_img_cloud = "";
        if (imageFile) {
          const formData = new FormData();
          formData.append("file", imageFile);
          formData.append("upload_preset", "store_img_user");

          const response = await axios.post(
            `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME_IMAGE_USER}/image/upload`,
            formData
          );
          url_img_cloud = response.data.secure_url;
        }
        const decoded = jwtDecode(user);
        const userId = decoded["sub"];
        await dispatch(
          updateInfoUser({
            userId: userId,
            newInfoUser: {
              ...formData,
              imageUrl: url_img_cloud
                ? url_img_cloud
                : selectedImage
                ? selectedImage
                : formData.imageUrl,
            },
          })
        ).unwrap();
        setUploading(false);
        setImageFile(null);
        setSelectedImage(null);
        toast.success("Cập nhật thông tin thành công!");
      }
    } catch (err) {
      setUploading(false);
      if (err.errors) {
        Object.values(err.errors).forEach((errorMsg) => {
          toast.error(errorMsg);
        });
      } else {
        toast.error(err.message || "Cập nhật thất bại!");
      }
    }
  };

  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="row">
            <Sidebar page="my-profile" />
            <div className="col-xl-9 col-lg-8">
              <div className="card settings mb-0">
                <div className="card-header">
                  <h6>Thiết lập</h6>
                </div>
                <div class="card-body pb-3">
                  <div class="settings-link d-flex align-items-center flex-wrap">
                    <Link href="/update-user" class="active ps-3">
                      <i class="isax isax-user-octagon me-2"></i>Chỉnh sửa thông
                      tin
                    </Link>
                    <Link to="/change-password">
                      <i class="isax isax-shield-tick me-2"></i>Bảo mật
                    </Link>
                  </div>
                  <div className="card-body pb-3">
                    <h6 className="fs-16 mb-3">Thông tin cơ bản</h6>
                    <div className="row gy-2">
                      <div className="col-lg-12">
                        <div className="d-flex align-items-center">
                          <img
                            src={selectedImage || formData.imageUrl || ""}
                            alt="image"
                            className="img-fluid avatar avatar-xxl br-10 flex-shrink-0 me-3"
                            style={{ objectFit: "cover" }}
                          />
                          <div>
                            <p className="fs-14 text-gray-6 fw-normal mb-2">
                              Kích thước được khuyến nghị là 400 x 400 pixel.
                            </p>
                            <div className="d-flex align-items-center">
                              <label
                                className="upload-btn btn"
                                htmlFor="fileUpload"
                              >
                                Tải lên
                              </label>
                              <input
                                type="file"
                                id="fileUpload"
                                style={{ display: "none" }}
                                onChange={handleImageChange}
                              />
                              {selectedImage ? (
                                <button
                                  className="btn btn-light btn-md ms-2"
                                  onClick={() => {
                                    setSelectedImage(null);
                                    setImageFile(null);
                                  }}
                                >
                                  Hủy
                                </button>
                              ) : (
                                <>
                                  {formData.imageUrl !==
                                  "https://res.cloudinary.com/dwk9eodsk/image/upload/v1741614219/default_user_f9c53u.png" ? (
                                    <button
                                      className="btn btn-light btn-md ms-2"
                                      onClick={() => {
                                        setSelectedImage(
                                          "https://res.cloudinary.com/dwk9eodsk/image/upload/v1741614219/default_user_f9c53u.png"
                                        );
                                      }}
                                    >
                                      Xóa
                                    </button>
                                  ) : (
                                    ""
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Input Họ và Tên */}
                      <div className="col-lg-6">
                        <label className="form-label">Tên</label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            name="fullName"
                            className={`form-control ${
                              errors.fullName ? "is-invalid" : ""
                            }`}
                            value={formData.fullName}
                            onChange={handleChange}
                          />
                          {!formData.fullName.trim() && (
                            <i className="fa-solid fa-triangle-exclamation text-warning ms-2"></i>
                          )}
                        </div>
                        {errors.fullName && (
                          <div className="text-danger">{errors.fullName}</div>
                        )}
                      </div>

                      {/* Input Địa chỉ (Không cần kiểm tra) */}
                      <div className="col-lg-6">
                        <label className="form-label">Địa chỉ</label>

                        <div className="d-flex align-items-center">
                          {/* <input
                            type="text"
                            name="address"
                            className={`form-control ${
                              errors.address ? "is-invalid" : ""
                            }`}
                            value={formData.address}
                            onChange={handleChange}
                          /> */}
                          <AddressMap
                            initialLocation={formData.address}
                            onLocationChange={handleLocationChange}
                          />
                          {!formData.address.trim() && (
                            <i className="fa-solid fa-triangle-exclamation text-warning ms-2"></i>
                          )}
                        </div>
                        {errors.address && (
                          <div className="text-danger">{errors.address}</div>
                        )}
                      </div>

                      {/* Input Email (Không chỉnh sửa) */}
                      <div className="col-lg-6">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          value={formData.email}
                          disabled
                        />
                      </div>

                      {/* Input Số điện thoại */}
                      <div className="col-lg-6">
                        <label className="form-label">Số điện thoại</label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            name="phoneNumber"
                            className={`form-control ${
                              errors.phoneNumber ? "is-invalid" : ""
                            }`}
                            value={formData.phoneNumber}
                            onChange={handleChange}
                          />
                          {!formData.phoneNumber.trim() && (
                            <i className="fa-solid fa-triangle-exclamation text-warning ms-2"></i>
                          )}
                        </div>
                        {errors.phoneNumber && (
                          <div className="text-danger">
                            {errors.phoneNumber}
                          </div>
                        )}
                      </div>
                      {/* Status Guide (chỉ hiển thị nếu là Tour Guide và status khác null/pending) */}
                      {/* Status Guide với react-select */}
                      {isTourGuide &&
                        formData.statusGuide &&
                        formData.statusGuide !== "Pending" && (
                          <div className="col-lg-6">
                            <label className="form-label">Trạng thái</label>
                            <Select
                              name="statusGuide"
                              className="status-select"
                              value={{
                                value: formData.statusGuide,
                                label: formData.statusGuide,
                              }}
                              onChange={(selectedOption) =>
                                handleChange({
                                  target: {
                                    name: "statusGuide",
                                    value: selectedOption.value,
                                  },
                                })
                              }
                              options={[
                                { value: "Available", label: "Available" },
                                { value: "Busy", label: "Busy" },
                              ]}
                              formatOptionLabel={({ value, label }) => (
                                <div className="status-option">
                                  <span
                                    className={`status-dot ${
                                      value === "Available"
                                        ? "dot-available"
                                        : "dot-busy"
                                    }`}
                                  ></span>
                                  {label}
                                </div>
                              )}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="d-flex align-items-center justify-content-end">
                    <Link to="/my-profile" className="btn btn-light me-2">
                      Hủy
                    </Link>
                    <button
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={uploading}
                    >
                      {uploading ? (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                      ) : (
                        <>Lưu</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UpdateUser;
